import {
  IPatientResponse,
  IPatientVitalSignsResponse
} from 'types/patient/types'

export const vitalSignsKeyList: Array<keyof IPatientVitalSignsResponse> = [
  'o2_saturation',
  'blood_pressure_systolic',
  'blood_pressure_diastolic',
  'temperature_celsius',
  'heart_rate_rest'
]

export type Tabs = 'active' | 'success' | 'discarded'

export const tabOptions: Tabs[] = ['active', 'success', 'discarded']

export type SortOption =
  | 'outdated'
  | 'outdated_48'
  | 'overall_calculation_warning'

export const sortOptions = [
  { value: 'outdated', label: 'Desatualizado' },
  { value: 'outdated_48', label: 'Desatualizado Crítico (+48h)' },
  { value: 'overall_calculation_warning', label: 'Alerta de saúde' }
]

export const getVitalSignsCount = (
  vital_signs?: IPatientVitalSignsResponse
): number => {
  if (!vital_signs) return 0

  return vitalSignsKeyList.filter(key => {
    return vital_signs[key] !== null && vital_signs[key] !== undefined
  }).length
}

export const sortPatients = (
  patients: IPatientResponse[],
  isHDA: boolean,
  sortBy: SortOption = 'outdated'
): IPatientResponse[] => {
  if (!isHDA) {
    const listWithNulls = patients.filter(a => a.overall_calculation === null)
    const listWithValue = patients
      .filter(a => a.overall_calculation !== null)
      .sort((a, b) => a.overall_calculation - b.overall_calculation)
    return listWithValue.concat(listWithNulls)
  }

  // HDA sorting with custom sort options
  const sorted = [...patients].sort((a, b) => {
    if (sortBy === 'outdated') {
      // Outdated first (true > false)
      const aOutdated = a.outdated ? 1 : 0
      const bOutdated = b.outdated ? 1 : 0
      return bOutdated - aOutdated
    } else if (sortBy === 'outdated_48') {
      // Outdated 48h first (critical)
      const aOutdated48 = a.outdated_48 ? 1 : 0
      const bOutdated48 = b.outdated_48 ? 1 : 0
      return bOutdated48 - aOutdated48
    } else if (sortBy === 'overall_calculation_warning') {
      // Higher warning values first (descending)
      const aWarning = a.overall_calculation_warning ?? 0
      const bWarning = b.overall_calculation_warning ?? 0
      return bWarning - aWarning
    }
    return 0
  })
  return sorted
}
